module.exports = __webpack_public_path__ + "static/media/gif.f0c05660.svg";